<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Alumni Governing Body"
                   :links="[{title:'Home', url:'/'},{title:'Alumni', url:''},{title: 'Governing Body', url: ''}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="3"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Alumni Governing Body</div>

          <div>
            <table class="achievements mt-3">
              <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Member</th>
                <th scope="col">Designation</th>
                <th scope="col">Photo</th>
              </tr>
              </thead>
              <tbody>
              <tr class="text-justify" v-for="(member,index) in members"
                  :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ member.name }}</td>
                <td>{{ member.designation }}</td>
                <td>
                  <img
                      class="w-5 sm:w-auto object-fill rounded-lg transition duration-500 ease-in-out transform  hover:scale-105"
                      :src="member.photo" alt="member">
                </td>
              </tr>
              </tbody>
            </table>
          </div>


        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/alumni/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "AlumniGoverningBody",
  components: {
    KeyRecruiters,
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,

  },
  data() {
    return {
      members: [
        {
          name: 'Sachin Govind Savant',
          designation: 'President',
          photo: '/static/images/alumni/governing_body/sachin_savant.jpg'
        }, {
          name: 'Swapnil Haishchanrda Thorat',
          designation: 'Vice President',
          photo: '/static/images/alumni/governing_body/swapnil_thorat.jpg'
        }, {
          name: 'Arvind Parashram Ghodake',
          designation: 'Secretary',
          photo: '/static/images/alumni/governing_body/arvind_ghodake.jpg'
        }, {
          name: 'Dattatraya Popat Kshrisagar',
          designation: 'Treasurer',
          photo: '/static/images/alumni/governing_body/dattatraya_khirsagar.jpg'
        }, {
          name: 'Jayant Pandurang Kenge',
          designation: 'Member',
          photo: '/static/images/alumni/governing_body/jayant_kenge.jpg'
        }, {
          name: 'Shubham Pramod Shinde',
          designation: 'Member',
          photo: '/static/images/alumni/governing_body/shubham_shinde.jpg'
        }, {
          name: 'Amol Pralhad Shinde',
          designation: 'Member',
          photo: '/static/images/alumni/governing_body/amol_shinde.jpg'
        },
      ]
    }
  }

}
</script>
<style lang="scss" scoped/>
